var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListNumber = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 23 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6 5.5a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0zm-.75 5.767a.366.366 0 0 1 .462.564l-1.316 1.315A.5.5 0 0 0 4.75 14H6.5a.5.5 0 0 0 0-1h-.543l.462-.462a1.366 1.366 0 0 0-1.723-2.103l-.223.149a.5.5 0 1 0 .554.832zm-.5 4.233a.5.5 0 0 0 0 1h.543l-.647.646A.5.5 0 0 0 5 18h.75a.25.25 0 1 1 0 .5h-1a.5.5 0 0 0 0 1h1a1.25 1.25 0 0 0 .394-2.437l.71-.71A.5.5 0 0 0 6.5 15.5zM9 6a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2zm0 5a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2zm0 5a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2z",
  clipRule: "evenodd"
})));
export default SvgListNumber;